import React, { useEffect, useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import PracticeMentorModal from "../PracticeMentor/PracticeMentorModal"
import PracticeMentorTable from '../PracticeMentor/PracticeMentorTable';
import {  getAllPH } from '../../../services/adminServices/AdminServices';
import { getAllCOE } from '../../../services/adminServices/CoeServices';

import { toast } from 'react-toastify';

const PracticeHead = () => {
    const [openModal, setOpenModal] = useState({ userForm: false });
    const [rowData, setRowData] = useState();
    const [allCOE, setCOE] = useState([]);
    const [editRowData, setEditRowData] = useState(null);
    const [userName, setUserName] = useState("")
    const [loading, setLoading] = useState(true);

    const handleModalToggle = (modalName, data = null) => {
        setOpenModal((prev) => ({ ...prev, [modalName]: !prev[modalName] }));
        if (!data) {
            setEditRowData(null);
        } else {
            setEditRowData(data);
        }
    };

    const getAllUsersData = async () => {
        try {
            setLoading(true);
            const allCOE = await getAllCOE();
            setCOE(allCOE.data.data)
            const response = await getAllPH();
            setRowData(response?.data?.data || []);
        } catch (error) {
            toast.error( error?.response?.data.message||error?.message ||error?.error);
        } finally {
            setLoading(false);
        }

    }

    const handleEditClick = (row) => {
        handleModalToggle('userForm', row);
    };

    useEffect(() => {
        const user = JSON.parse(localStorage.getItem("user"))
        setUserName(user?.name)
        getAllUsersData();
    }, []);

    return (
        <Box className="dashboard-container">
            <Box className="dashboard-header">
                <Typography className="dashboard-header-title">Welcome {userName}</Typography>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => handleModalToggle('userForm')}
                    className="dashboard-header-button PH-title">
                    CREATE Practice Head
                </Button>
            </Box>
            <PracticeMentorModal
                open={openModal.userForm}
                onClose={() => handleModalToggle('userForm')}
                title={"Head"}
                rowData={editRowData}
                allCOE={allCOE}
                getAllUsersData={getAllUsersData}
            />
            <Box className="dashboard-box-container">
                <PracticeMentorTable
                    rows={rowData}
                    allCOE={allCOE}
                    loading={loading}
                    emptyMessage="No Practice Heads found."
                    onEditClick={handleEditClick}
                    getAllUsersData={getAllUsersData}
                />
            </Box>
        </Box>
    );
};

export default PracticeHead;
